import type { Comment } from "@circle-react/types/Comment";
import reject from "lodash/reject";
import { useState } from "react";

interface UseCommentsListManagementParams {
  initialComments?: Comment[];
}

export const useCommentsListManagement = ({
  initialComments = [],
}: UseCommentsListManagementParams = {}) => {
  const [comments, setComments] = useState<Comment[]>(initialComments);

  const addCommentToList = (comment: Comment) =>
    setComments(prevComments => [...prevComments, comment]);

  const updateCommentInList = (comment: Comment) =>
    setComments(prevComments =>
      prevComments.map(prevComment =>
        prevComment.id === comment.id ? comment : prevComment,
      ),
    );

  const removeCommentFromList = ({ id }: { id: string | number }) =>
    setComments(prevComments => reject(prevComments, ["id", id]));

  return {
    comments,
    setComments,
    addCommentToList,
    updateCommentInList,
    removeCommentFromList,
  };
};
